export default {
  ADD_FILE_NAME(state, fileName) {
    state.fileNames.push(fileName);
  },
  CLEAR_FILE_NAMES(state) {
    state.fileNames = [];
  },
};
